import React from 'react'

export function renderCheckboxField(field)
{
	const color = field.labelColor !== undefined ? field.labelColor:'black';
	const fontWeight = field.labelColor !== undefined ? 'bold':'normal';
	return (
		<label className={`checkbox-inline c-checkbox`} style={{ color:color, fontWeight:fontWeight }}>
			<input  {...field.input}  type="checkbox" name={field.name} checked={field.checked} disabled={field.disabled} />
			<em className="fa fa-check" />&nbsp;&nbsp;{field.label}
		</label> 
	)
}



// WEBPACK FOOTER //
// ./src/modules/components/checkboxfieldcomponent.js